import {
  PrimitiveArraySerializer6xcmeltdozbx as PrimitiveArraySerializer,
  PrimitiveArrayBuilder1tzna3i4eqw54 as PrimitiveArrayBuilder,
} from './CollectionSerializers.mjs';
import { Companion_getInstance2me39a222cg9k as Companion_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  serializer345btyh1f2y1j as serializer,
  serializer1wpgysz06u9ol as serializer_0,
  serializer3x9uckd1deom as serializer_1,
  serializerodflzzf6s3fp as serializer_2,
  serializer2lw83vwvpnyms as serializer_3,
  serializer1hu9wv9at41ww as serializer_4,
  serializer3ikrxnm8b29d6 as serializer_5,
  serializer1tw0a8bv7lkga as serializer_6,
  serializer1q7c5q67ysppr as serializer_7,
  serializer1r0h5yakm679b as serializer_8,
  serializer36584sjyg5661 as serializer_9,
  serializer3u3hsxnenk49x as serializer_10,
} from '../builtins/BuiltinSerializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isCharArray21auq5hbrg68m as isCharArray,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  isFloatArrayjjscnqphw92j as isFloatArray,
  isIntArrayeijsubfngq38 as isIntArray,
  isShortArraywz30zxwtqi8h as isShortArray,
  isByteArray4nnzfn1x4o3w as isByteArray,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  charArray2ujmm1qusno00 as charArray,
  booleanArray2jdug9b51huk7 as booleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DoubleCompanionObject_instance2owjtjg73ep4r as DoubleCompanionObject_instance,
  FloatCompanionObject_instance1ya67s5frsek3 as FloatCompanionObject_instance,
  IntCompanionObject_instanceru1css19onx6 as IntCompanionObject_instance,
  ShortCompanionObject_instance28ym5go6niq9r as ShortCompanionObject_instance,
  ByteCompanionObject_instance3kkatsq6s1rq7 as ByteCompanionObject_instance,
  BooleanCompanionObject_instancem7duqvmx6ml6 as BooleanCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { Companion_instance3g2kzoy08jm6r as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import { isLongArray21mxwb8b0y2ii as isLongArray } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  Companion_getInstancehe6v7kxreu2f as Companion_getInstance_0,
  _ULong___init__impl__c78o9k3fkiaf1q5xsf7 as _ULong___init__impl__c78o9k,
  _ULong___get_data__impl__fggpzb35t7vg7og3i8u as _ULong___get_data__impl__fggpzb,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  _ULongArray___get_size__impl__ju6dtr294dl6tm51vl0 as _ULongArray___get_size__impl__ju6dtr,
  ULongArray3nd0d80mdwjj8 as ULongArray,
  _ULongArray___init__impl__twm1l33hs41a6eujp5f as _ULongArray___init__impl__twm1l3,
  ULongArray__get_impl_pr71q92wbpzmu6hb05i as ULongArray__get_impl_pr71q9,
  _ULongArray___get_storage__impl__28e64j17j1wffnse0mq as _ULongArray___get_storage__impl__28e64j,
  _ULongArray___init__impl__twm1l327hyqbmoo3gha as _ULongArray___init__impl__twm1l3_0,
  ULongArray__set_impl_z19mvh7mby1284z6pf as ULongArray__set_impl_z19mvh,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULongArray.mjs';
import {
  Companion_getInstance2bqk1h54tdzgh as Companion_getInstance_1,
  _UInt___init__impl__l7qpdl2rn8hu5x5mgv2 as _UInt___init__impl__l7qpdl,
  _UInt___get_data__impl__f0vqqw18g8a2o14g87q as _UInt___get_data__impl__f0vqqw,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _UIntArray___get_size__impl__r6l8ci13q5tym30x5f8 as _UIntArray___get_size__impl__r6l8ci,
  UIntArrayrp6cv44n5v4y as UIntArray,
  _UIntArray___init__impl__ghjpc61d4fxfei6kfsc as _UIntArray___init__impl__ghjpc6,
  UIntArray__get_impl_gp5kza1vhqxkvvk9rrv as UIntArray__get_impl_gp5kza,
  _UIntArray___get_storage__impl__92a0v03tsugia02e3ye as _UIntArray___get_storage__impl__92a0v0,
  _UIntArray___init__impl__ghjpc62t4adv3l2o8r9 as _UIntArray___init__impl__ghjpc6_0,
  UIntArray__set_impl_7f2zu23un3gauvkblmo as UIntArray__set_impl_7f2zu2,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UIntArray.mjs';
import {
  Companion_getInstancehpp5w6ty1u0b as Companion_getInstance_2,
  _UShort___init__impl__jigrne1zu56ujvuii2n as _UShort___init__impl__jigrne,
  _UShort___get_data__impl__g02451joe1vsk2vach as _UShort___get_data__impl__g0245,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import {
  _UShortArray___get_size__impl__jqto1b26bmy1f82up0s as _UShortArray___get_size__impl__jqto1b,
  UShortArray11avpmknxdgvv as UShortArray,
  _UShortArray___init__impl__9b26ef1072738vvd6x4 as _UShortArray___init__impl__9b26ef,
  UShortArray__get_impl_fnbhmx33wy68opzjz82 as UShortArray__get_impl_fnbhmx,
  _UShortArray___get_storage__impl__t2jpv515u9xaqouraih as _UShortArray___get_storage__impl__t2jpv5,
  _UShortArray___init__impl__9b26ef3n6f83gmc4g92 as _UShortArray___init__impl__9b26ef_0,
  UShortArray__set_impl_6d8whp3leme2hhamxoe as UShortArray__set_impl_6d8whp,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShortArray.mjs';
import {
  Companion_getInstance29en1y99grgx1 as Companion_getInstance_3,
  _UByte___init__impl__g9hnc430zp6cgd9f0jq as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qryxuf3cmdpzyk as _UByte___get_data__impl__jof9qr,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UByteArray___get_size__impl__h6pkdv2q8ncjn6v8oz0 as _UByteArray___get_size__impl__h6pkdv,
  UByteArray2qu4d6gwssdf9 as UByteArray,
  _UByteArray___init__impl__ip4y9n1ymkr3h4vpfmg as _UByteArray___init__impl__ip4y9n,
  UByteArray__get_impl_t5f3hvbbj411cc05mf as UByteArray__get_impl_t5f3hv,
  _UByteArray___get_storage__impl__d4kcttp6btvbau0f8b as _UByteArray___get_storage__impl__d4kctt,
  _UByteArray___init__impl__ip4y9n15i9if485vlfd as _UByteArray___init__impl__ip4y9n_0,
  UByteArray__set_impl_jvcicn2hmfyga0u5ve0 as UByteArray__set_impl_jvcicn,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByteArray.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  copyOf2p23ljc5f5ea3 as copyOf,
  copyOfgossjg6lh6js as copyOf_0,
  copyOfq9pcgcgbldck as copyOf_1,
  copyOf9mbsebmgnw4t as copyOf_2,
  copyOf3rutauicler23 as copyOf_3,
  copyOf39s58md6y6rn6 as copyOf_4,
  copyOfwy6h3t5vzqpl as copyOf_5,
  copyOf37mht4mx7mjgh as copyOf_6,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CharArraySerializerClass;
function CharArraySerializer() {
  if (CharArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        CharArraySerializer_instance = null;
        super(serializer(Companion_getInstance()));
        CharArraySerializer_instance = this;
      }
      w1z(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      l1v(_this__u8e3s4) {
        return this.w1z((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      x1z(_this__u8e3s4) {
        return new (CharArrayBuilder())(_this__u8e3s4);
      }
      g1u(_this__u8e3s4) {
        return this.x1z((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      w1w() {
        return charArray(0);
      }
      y1z(decoder, index, builder, checkIndex) {
        builder.b20(decoder.g1r(this.n1w_1, index));
      }
      r1u(decoder, index, builder, checkIndex) {
        return this.y1z(decoder, index, builder instanceof CharArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      x1w(decoder, index, builder, checkIndex) {
        return this.y1z(decoder, index, builder instanceof CharArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      c20(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.m1s(this.n1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      y1w(encoder, content, size) {
        return this.c20(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'CharArraySerializer', VOID, VOID, [KSerializer()]);
    CharArraySerializerClass = $;
  }
  return CharArraySerializerClass;
}
var CharArraySerializer_instance;
function CharArraySerializer_getInstance() {
  if (CharArraySerializer_instance === VOID)
    new (CharArraySerializer())();
  return CharArraySerializer_instance;
}
var DoubleArraySerializerClass;
function DoubleArraySerializer() {
  if (DoubleArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        DoubleArraySerializer_instance = null;
        super(serializer_0(DoubleCompanionObject_instance));
        DoubleArraySerializer_instance = this;
      }
      f20(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      l1v(_this__u8e3s4) {
        return this.f20((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      g20(_this__u8e3s4) {
        return new (DoubleArrayBuilder())(_this__u8e3s4);
      }
      g1u(_this__u8e3s4) {
        return this.g20((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      w1w() {
        return new Float64Array(0);
      }
      h20(decoder, index, builder, checkIndex) {
        builder.k20(decoder.f1r(this.n1w_1, index));
      }
      r1u(decoder, index, builder, checkIndex) {
        return this.h20(decoder, index, builder instanceof DoubleArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      x1w(decoder, index, builder, checkIndex) {
        return this.h20(decoder, index, builder instanceof DoubleArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      l20(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.l1s(this.n1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      y1w(encoder, content, size) {
        return this.l20(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'DoubleArraySerializer', VOID, VOID, [KSerializer()]);
    DoubleArraySerializerClass = $;
  }
  return DoubleArraySerializerClass;
}
var DoubleArraySerializer_instance;
function DoubleArraySerializer_getInstance() {
  if (DoubleArraySerializer_instance === VOID)
    new (DoubleArraySerializer())();
  return DoubleArraySerializer_instance;
}
var FloatArraySerializerClass;
function FloatArraySerializer() {
  if (FloatArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        FloatArraySerializer_instance = null;
        super(serializer_1(FloatCompanionObject_instance));
        FloatArraySerializer_instance = this;
      }
      o20(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      l1v(_this__u8e3s4) {
        return this.o20((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      p20(_this__u8e3s4) {
        return new (FloatArrayBuilder())(_this__u8e3s4);
      }
      g1u(_this__u8e3s4) {
        return this.p20((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      w1w() {
        return new Float32Array(0);
      }
      q20(decoder, index, builder, checkIndex) {
        builder.t20(decoder.e1r(this.n1w_1, index));
      }
      r1u(decoder, index, builder, checkIndex) {
        return this.q20(decoder, index, builder instanceof FloatArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      x1w(decoder, index, builder, checkIndex) {
        return this.q20(decoder, index, builder instanceof FloatArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      u20(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.k1s(this.n1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      y1w(encoder, content, size) {
        return this.u20(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'FloatArraySerializer', VOID, VOID, [KSerializer()]);
    FloatArraySerializerClass = $;
  }
  return FloatArraySerializerClass;
}
var FloatArraySerializer_instance;
function FloatArraySerializer_getInstance() {
  if (FloatArraySerializer_instance === VOID)
    new (FloatArraySerializer())();
  return FloatArraySerializer_instance;
}
var LongArraySerializerClass;
function LongArraySerializer() {
  if (LongArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        LongArraySerializer_instance = null;
        super(serializer_2(Companion_instance));
        LongArraySerializer_instance = this;
      }
      x20(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      l1v(_this__u8e3s4) {
        return this.x20((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      y20(_this__u8e3s4) {
        return new (LongArrayBuilder())(_this__u8e3s4);
      }
      g1u(_this__u8e3s4) {
        return this.y20((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      w1w() {
        return new BigInt64Array(0);
      }
      z20(decoder, index, builder, checkIndex) {
        builder.c21(decoder.d1r(this.n1w_1, index));
      }
      r1u(decoder, index, builder, checkIndex) {
        return this.z20(decoder, index, builder instanceof LongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      x1w(decoder, index, builder, checkIndex) {
        return this.z20(decoder, index, builder instanceof LongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.j1s(this.n1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      y1w(encoder, content, size) {
        return this.d21(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'LongArraySerializer', VOID, VOID, [KSerializer()]);
    LongArraySerializerClass = $;
  }
  return LongArraySerializerClass;
}
var LongArraySerializer_instance;
function LongArraySerializer_getInstance() {
  if (LongArraySerializer_instance === VOID)
    new (LongArraySerializer())();
  return LongArraySerializer_instance;
}
var ULongArraySerializerClass;
function ULongArraySerializer() {
  if (ULongArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ULongArraySerializer_instance = null;
        super(serializer_3(Companion_getInstance_0()));
        ULongArraySerializer_instance = this;
      }
      g21(_this__u8e3s4) {
        return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
      }
      l1v(_this__u8e3s4) {
        return this.g21(_this__u8e3s4 instanceof ULongArray() ? _this__u8e3s4.bv_1 : THROW_CCE());
      }
      h21(_this__u8e3s4) {
        return new (ULongArrayBuilder())(_this__u8e3s4);
      }
      g1u(_this__u8e3s4) {
        return this.h21(_this__u8e3s4 instanceof ULongArray() ? _this__u8e3s4.bv_1 : THROW_CCE());
      }
      i21() {
        return _ULongArray___init__impl__twm1l3(0);
      }
      w1w() {
        return new (ULongArray())(this.i21());
      }
      j21(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toULong' call
        var this_0 = decoder.i1r(this.n1w_1, index).o1q();
        var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
        builder.m21(tmp$ret$0);
      }
      r1u(decoder, index, builder, checkIndex) {
        return this.j21(decoder, index, builder instanceof ULongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      x1w(decoder, index, builder, checkIndex) {
        return this.j21(decoder, index, builder instanceof ULongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      n21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.o1s(this.n1w_1, i);
            // Inline function 'kotlin.ULong.toLong' call
            var this_0 = ULongArray__get_impl_pr71q9(content, i);
            var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
            tmp.y1r(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      y1w(encoder, content, size) {
        return this.n21(encoder, content instanceof ULongArray() ? content.bv_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ULongArraySerializer', VOID, VOID, [KSerializer()]);
    ULongArraySerializerClass = $;
  }
  return ULongArraySerializerClass;
}
var ULongArraySerializer_instance;
function ULongArraySerializer_getInstance() {
  if (ULongArraySerializer_instance === VOID)
    new (ULongArraySerializer())();
  return ULongArraySerializer_instance;
}
var IntArraySerializerClass;
function IntArraySerializer() {
  if (IntArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        IntArraySerializer_instance = null;
        super(serializer_4(IntCompanionObject_instance));
        IntArraySerializer_instance = this;
      }
      q21(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      l1v(_this__u8e3s4) {
        return this.q21((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      r21(_this__u8e3s4) {
        return new (IntArrayBuilder())(_this__u8e3s4);
      }
      g1u(_this__u8e3s4) {
        return this.r21((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      w1w() {
        return new Int32Array(0);
      }
      s21(decoder, index, builder, checkIndex) {
        builder.v21(decoder.c1r(this.n1w_1, index));
      }
      r1u(decoder, index, builder, checkIndex) {
        return this.s21(decoder, index, builder instanceof IntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      x1w(decoder, index, builder, checkIndex) {
        return this.s21(decoder, index, builder instanceof IntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      w21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.i1s(this.n1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      y1w(encoder, content, size) {
        return this.w21(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'IntArraySerializer', VOID, VOID, [KSerializer()]);
    IntArraySerializerClass = $;
  }
  return IntArraySerializerClass;
}
var IntArraySerializer_instance;
function IntArraySerializer_getInstance() {
  if (IntArraySerializer_instance === VOID)
    new (IntArraySerializer())();
  return IntArraySerializer_instance;
}
var UIntArraySerializerClass;
function UIntArraySerializer() {
  if (UIntArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UIntArraySerializer_instance = null;
        super(serializer_5(Companion_getInstance_1()));
        UIntArraySerializer_instance = this;
      }
      z21(_this__u8e3s4) {
        return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
      }
      l1v(_this__u8e3s4) {
        return this.z21(_this__u8e3s4 instanceof UIntArray() ? _this__u8e3s4.qu_1 : THROW_CCE());
      }
      a22(_this__u8e3s4) {
        return new (UIntArrayBuilder())(_this__u8e3s4);
      }
      g1u(_this__u8e3s4) {
        return this.a22(_this__u8e3s4 instanceof UIntArray() ? _this__u8e3s4.qu_1 : THROW_CCE());
      }
      b22() {
        return _UIntArray___init__impl__ghjpc6(0);
      }
      w1w() {
        return new (UIntArray())(this.b22());
      }
      c22(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = decoder.i1r(this.n1w_1, index).n1q();
        var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
        builder.f22(tmp$ret$0);
      }
      r1u(decoder, index, builder, checkIndex) {
        return this.c22(decoder, index, builder instanceof UIntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      x1w(decoder, index, builder, checkIndex) {
        return this.c22(decoder, index, builder instanceof UIntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      g22(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.o1s(this.n1w_1, i);
            // Inline function 'kotlin.UInt.toInt' call
            var this_0 = UIntArray__get_impl_gp5kza(content, i);
            var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
            tmp.x1r(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      y1w(encoder, content, size) {
        return this.g22(encoder, content instanceof UIntArray() ? content.qu_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UIntArraySerializer', VOID, VOID, [KSerializer()]);
    UIntArraySerializerClass = $;
  }
  return UIntArraySerializerClass;
}
var UIntArraySerializer_instance;
function UIntArraySerializer_getInstance() {
  if (UIntArraySerializer_instance === VOID)
    new (UIntArraySerializer())();
  return UIntArraySerializer_instance;
}
var ShortArraySerializerClass;
function ShortArraySerializer() {
  if (ShortArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ShortArraySerializer_instance = null;
        super(serializer_6(ShortCompanionObject_instance));
        ShortArraySerializer_instance = this;
      }
      j22(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      l1v(_this__u8e3s4) {
        return this.j22((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      k22(_this__u8e3s4) {
        return new (ShortArrayBuilder())(_this__u8e3s4);
      }
      g1u(_this__u8e3s4) {
        return this.k22((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      w1w() {
        return new Int16Array(0);
      }
      l22(decoder, index, builder, checkIndex) {
        builder.o22(decoder.b1r(this.n1w_1, index));
      }
      r1u(decoder, index, builder, checkIndex) {
        return this.l22(decoder, index, builder instanceof ShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      x1w(decoder, index, builder, checkIndex) {
        return this.l22(decoder, index, builder instanceof ShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      p22(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.h1s(this.n1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      y1w(encoder, content, size) {
        return this.p22(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ShortArraySerializer', VOID, VOID, [KSerializer()]);
    ShortArraySerializerClass = $;
  }
  return ShortArraySerializerClass;
}
var ShortArraySerializer_instance;
function ShortArraySerializer_getInstance() {
  if (ShortArraySerializer_instance === VOID)
    new (ShortArraySerializer())();
  return ShortArraySerializer_instance;
}
var UShortArraySerializerClass;
function UShortArraySerializer() {
  if (UShortArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UShortArraySerializer_instance = null;
        super(serializer_7(Companion_getInstance_2()));
        UShortArraySerializer_instance = this;
      }
      s22(_this__u8e3s4) {
        return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
      }
      l1v(_this__u8e3s4) {
        return this.s22(_this__u8e3s4 instanceof UShortArray() ? _this__u8e3s4.mv_1 : THROW_CCE());
      }
      t22(_this__u8e3s4) {
        return new (UShortArrayBuilder())(_this__u8e3s4);
      }
      g1u(_this__u8e3s4) {
        return this.t22(_this__u8e3s4 instanceof UShortArray() ? _this__u8e3s4.mv_1 : THROW_CCE());
      }
      u22() {
        return _UShortArray___init__impl__9b26ef(0);
      }
      w1w() {
        return new (UShortArray())(this.u22());
      }
      v22(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = decoder.i1r(this.n1w_1, index).m1q();
        var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
        builder.y22(tmp$ret$0);
      }
      r1u(decoder, index, builder, checkIndex) {
        return this.v22(decoder, index, builder instanceof UShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      x1w(decoder, index, builder, checkIndex) {
        return this.v22(decoder, index, builder instanceof UShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      z22(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.o1s(this.n1w_1, i);
            // Inline function 'kotlin.UShort.toShort' call
            var this_0 = UShortArray__get_impl_fnbhmx(content, i);
            var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
            tmp.w1r(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      y1w(encoder, content, size) {
        return this.z22(encoder, content instanceof UShortArray() ? content.mv_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UShortArraySerializer', VOID, VOID, [KSerializer()]);
    UShortArraySerializerClass = $;
  }
  return UShortArraySerializerClass;
}
var UShortArraySerializer_instance;
function UShortArraySerializer_getInstance() {
  if (UShortArraySerializer_instance === VOID)
    new (UShortArraySerializer())();
  return UShortArraySerializer_instance;
}
var ByteArraySerializerClass;
function ByteArraySerializer() {
  if (ByteArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ByteArraySerializer_instance = null;
        super(serializer_8(ByteCompanionObject_instance));
        ByteArraySerializer_instance = this;
      }
      c23(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      l1v(_this__u8e3s4) {
        return this.c23((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      d23(_this__u8e3s4) {
        return new (ByteArrayBuilder())(_this__u8e3s4);
      }
      g1u(_this__u8e3s4) {
        return this.d23((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      w1w() {
        return new Int8Array(0);
      }
      e23(decoder, index, builder, checkIndex) {
        builder.h23(decoder.a1r(this.n1w_1, index));
      }
      r1u(decoder, index, builder, checkIndex) {
        return this.e23(decoder, index, builder instanceof ByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      x1w(decoder, index, builder, checkIndex) {
        return this.e23(decoder, index, builder instanceof ByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i23(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.g1s(this.n1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      y1w(encoder, content, size) {
        return this.i23(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ByteArraySerializer', VOID, VOID, [KSerializer()]);
    ByteArraySerializerClass = $;
  }
  return ByteArraySerializerClass;
}
var ByteArraySerializer_instance;
function ByteArraySerializer_getInstance() {
  if (ByteArraySerializer_instance === VOID)
    new (ByteArraySerializer())();
  return ByteArraySerializer_instance;
}
var UByteArraySerializerClass;
function UByteArraySerializer() {
  if (UByteArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UByteArraySerializer_instance = null;
        super(serializer_9(Companion_getInstance_3()));
        UByteArraySerializer_instance = this;
      }
      l23(_this__u8e3s4) {
        return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
      }
      l1v(_this__u8e3s4) {
        return this.l23(_this__u8e3s4 instanceof UByteArray() ? _this__u8e3s4.fu_1 : THROW_CCE());
      }
      m23(_this__u8e3s4) {
        return new (UByteArrayBuilder())(_this__u8e3s4);
      }
      g1u(_this__u8e3s4) {
        return this.m23(_this__u8e3s4 instanceof UByteArray() ? _this__u8e3s4.fu_1 : THROW_CCE());
      }
      n23() {
        return _UByteArray___init__impl__ip4y9n(0);
      }
      w1w() {
        return new (UByteArray())(this.n23());
      }
      o23(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = decoder.i1r(this.n1w_1, index).l1q();
        var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
        builder.r23(tmp$ret$0);
      }
      r1u(decoder, index, builder, checkIndex) {
        return this.o23(decoder, index, builder instanceof UByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      x1w(decoder, index, builder, checkIndex) {
        return this.o23(decoder, index, builder instanceof UByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      s23(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.o1s(this.n1w_1, i);
            // Inline function 'kotlin.UByte.toByte' call
            var this_0 = UByteArray__get_impl_t5f3hv(content, i);
            var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
            tmp.v1r(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      y1w(encoder, content, size) {
        return this.s23(encoder, content instanceof UByteArray() ? content.fu_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UByteArraySerializer', VOID, VOID, [KSerializer()]);
    UByteArraySerializerClass = $;
  }
  return UByteArraySerializerClass;
}
var UByteArraySerializer_instance;
function UByteArraySerializer_getInstance() {
  if (UByteArraySerializer_instance === VOID)
    new (UByteArraySerializer())();
  return UByteArraySerializer_instance;
}
var BooleanArraySerializerClass;
function BooleanArraySerializer() {
  if (BooleanArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        BooleanArraySerializer_instance = null;
        super(serializer_10(BooleanCompanionObject_instance));
        BooleanArraySerializer_instance = this;
      }
      v23(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      l1v(_this__u8e3s4) {
        return this.v23((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      w23(_this__u8e3s4) {
        return new (BooleanArrayBuilder())(_this__u8e3s4);
      }
      g1u(_this__u8e3s4) {
        return this.w23((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      w1w() {
        return booleanArray(0);
      }
      x23(decoder, index, builder, checkIndex) {
        builder.a24(decoder.z1q(this.n1w_1, index));
      }
      r1u(decoder, index, builder, checkIndex) {
        return this.x23(decoder, index, builder instanceof BooleanArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      x1w(decoder, index, builder, checkIndex) {
        return this.x23(decoder, index, builder instanceof BooleanArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      b24(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.f1s(this.n1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      y1w(encoder, content, size) {
        return this.b24(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'BooleanArraySerializer', VOID, VOID, [KSerializer()]);
    BooleanArraySerializerClass = $;
  }
  return BooleanArraySerializerClass;
}
var BooleanArraySerializer_instance;
function BooleanArraySerializer_getInstance() {
  if (BooleanArraySerializer_instance === VOID)
    new (BooleanArraySerializer())();
  return BooleanArraySerializer_instance;
}
var CharArrayBuilderClass;
function CharArrayBuilder() {
  if (CharArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.z1z_1 = bufferWithData;
        this.a20_1 = bufferWithData.length;
        this.t1w(10);
      }
      p1w() {
        return this.a20_1;
      }
      t1w(requiredCapacity) {
        if (this.z1z_1.length < requiredCapacity)
          this.z1z_1 = copyOf(this.z1z_1, coerceAtLeast(requiredCapacity, imul(this.z1z_1.length, 2)));
      }
      b20(c) {
        this.a1x();
        var tmp = this.z1z_1;
        var _unary__edvuaz = this.a20_1;
        this.a20_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      r1w() {
        return copyOf(this.z1z_1, this.a20_1);
      }
    }
    initMetadataForClass($, 'CharArrayBuilder');
    CharArrayBuilderClass = $;
  }
  return CharArrayBuilderClass;
}
var DoubleArrayBuilderClass;
function DoubleArrayBuilder() {
  if (DoubleArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.i20_1 = bufferWithData;
        this.j20_1 = bufferWithData.length;
        this.t1w(10);
      }
      p1w() {
        return this.j20_1;
      }
      t1w(requiredCapacity) {
        if (this.i20_1.length < requiredCapacity)
          this.i20_1 = copyOf_0(this.i20_1, coerceAtLeast(requiredCapacity, imul(this.i20_1.length, 2)));
      }
      k20(c) {
        this.a1x();
        var tmp = this.i20_1;
        var _unary__edvuaz = this.j20_1;
        this.j20_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      r1w() {
        return copyOf_0(this.i20_1, this.j20_1);
      }
    }
    initMetadataForClass($, 'DoubleArrayBuilder');
    DoubleArrayBuilderClass = $;
  }
  return DoubleArrayBuilderClass;
}
var FloatArrayBuilderClass;
function FloatArrayBuilder() {
  if (FloatArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.r20_1 = bufferWithData;
        this.s20_1 = bufferWithData.length;
        this.t1w(10);
      }
      p1w() {
        return this.s20_1;
      }
      t1w(requiredCapacity) {
        if (this.r20_1.length < requiredCapacity)
          this.r20_1 = copyOf_1(this.r20_1, coerceAtLeast(requiredCapacity, imul(this.r20_1.length, 2)));
      }
      t20(c) {
        this.a1x();
        var tmp = this.r20_1;
        var _unary__edvuaz = this.s20_1;
        this.s20_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      r1w() {
        return copyOf_1(this.r20_1, this.s20_1);
      }
    }
    initMetadataForClass($, 'FloatArrayBuilder');
    FloatArrayBuilderClass = $;
  }
  return FloatArrayBuilderClass;
}
var LongArrayBuilderClass;
function LongArrayBuilder() {
  if (LongArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.a21_1 = bufferWithData;
        this.b21_1 = bufferWithData.length;
        this.t1w(10);
      }
      p1w() {
        return this.b21_1;
      }
      t1w(requiredCapacity) {
        if (this.a21_1.length < requiredCapacity)
          this.a21_1 = copyOf_2(this.a21_1, coerceAtLeast(requiredCapacity, imul(this.a21_1.length, 2)));
      }
      c21(c) {
        this.a1x();
        var tmp = this.a21_1;
        var _unary__edvuaz = this.b21_1;
        this.b21_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      r1w() {
        return copyOf_2(this.a21_1, this.b21_1);
      }
    }
    initMetadataForClass($, 'LongArrayBuilder');
    LongArrayBuilderClass = $;
  }
  return LongArrayBuilderClass;
}
var ULongArrayBuilderClass;
function ULongArrayBuilder() {
  if (ULongArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.k21_1 = bufferWithData;
        this.l21_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
        this.t1w(10);
      }
      p1w() {
        return this.l21_1;
      }
      t1w(requiredCapacity) {
        if (_ULongArray___get_size__impl__ju6dtr(this.k21_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.k21_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.k21_1), 2));
          tmp.k21_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
        }
      }
      m21(c) {
        this.a1x();
        var tmp = this.k21_1;
        var _unary__edvuaz = this.l21_1;
        this.l21_1 = _unary__edvuaz + 1 | 0;
        ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
      }
      c24() {
        var tmp0 = this.k21_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.l21_1;
        return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
      }
      r1w() {
        return new (ULongArray())(this.c24());
      }
    }
    initMetadataForClass($, 'ULongArrayBuilder');
    ULongArrayBuilderClass = $;
  }
  return ULongArrayBuilderClass;
}
var IntArrayBuilderClass;
function IntArrayBuilder() {
  if (IntArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.t21_1 = bufferWithData;
        this.u21_1 = bufferWithData.length;
        this.t1w(10);
      }
      p1w() {
        return this.u21_1;
      }
      t1w(requiredCapacity) {
        if (this.t21_1.length < requiredCapacity)
          this.t21_1 = copyOf_3(this.t21_1, coerceAtLeast(requiredCapacity, imul(this.t21_1.length, 2)));
      }
      v21(c) {
        this.a1x();
        var tmp = this.t21_1;
        var _unary__edvuaz = this.u21_1;
        this.u21_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      r1w() {
        return copyOf_3(this.t21_1, this.u21_1);
      }
    }
    initMetadataForClass($, 'IntArrayBuilder');
    IntArrayBuilderClass = $;
  }
  return IntArrayBuilderClass;
}
var UIntArrayBuilderClass;
function UIntArrayBuilder() {
  if (UIntArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.d22_1 = bufferWithData;
        this.e22_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
        this.t1w(10);
      }
      p1w() {
        return this.e22_1;
      }
      t1w(requiredCapacity) {
        if (_UIntArray___get_size__impl__r6l8ci(this.d22_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.d22_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.d22_1), 2));
          tmp.d22_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
        }
      }
      f22(c) {
        this.a1x();
        var tmp = this.d22_1;
        var _unary__edvuaz = this.e22_1;
        this.e22_1 = _unary__edvuaz + 1 | 0;
        UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
      }
      d24() {
        var tmp0 = this.d22_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.e22_1;
        return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
      }
      r1w() {
        return new (UIntArray())(this.d24());
      }
    }
    initMetadataForClass($, 'UIntArrayBuilder');
    UIntArrayBuilderClass = $;
  }
  return UIntArrayBuilderClass;
}
var ShortArrayBuilderClass;
function ShortArrayBuilder() {
  if (ShortArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.m22_1 = bufferWithData;
        this.n22_1 = bufferWithData.length;
        this.t1w(10);
      }
      p1w() {
        return this.n22_1;
      }
      t1w(requiredCapacity) {
        if (this.m22_1.length < requiredCapacity)
          this.m22_1 = copyOf_4(this.m22_1, coerceAtLeast(requiredCapacity, imul(this.m22_1.length, 2)));
      }
      o22(c) {
        this.a1x();
        var tmp = this.m22_1;
        var _unary__edvuaz = this.n22_1;
        this.n22_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      r1w() {
        return copyOf_4(this.m22_1, this.n22_1);
      }
    }
    initMetadataForClass($, 'ShortArrayBuilder');
    ShortArrayBuilderClass = $;
  }
  return ShortArrayBuilderClass;
}
var UShortArrayBuilderClass;
function UShortArrayBuilder() {
  if (UShortArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.w22_1 = bufferWithData;
        this.x22_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
        this.t1w(10);
      }
      p1w() {
        return this.x22_1;
      }
      t1w(requiredCapacity) {
        if (_UShortArray___get_size__impl__jqto1b(this.w22_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.w22_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.w22_1), 2));
          tmp.w22_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
        }
      }
      y22(c) {
        this.a1x();
        var tmp = this.w22_1;
        var _unary__edvuaz = this.x22_1;
        this.x22_1 = _unary__edvuaz + 1 | 0;
        UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
      }
      e24() {
        var tmp0 = this.w22_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.x22_1;
        return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
      }
      r1w() {
        return new (UShortArray())(this.e24());
      }
    }
    initMetadataForClass($, 'UShortArrayBuilder');
    UShortArrayBuilderClass = $;
  }
  return UShortArrayBuilderClass;
}
var ByteArrayBuilderClass;
function ByteArrayBuilder() {
  if (ByteArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.f23_1 = bufferWithData;
        this.g23_1 = bufferWithData.length;
        this.t1w(10);
      }
      p1w() {
        return this.g23_1;
      }
      t1w(requiredCapacity) {
        if (this.f23_1.length < requiredCapacity)
          this.f23_1 = copyOf_5(this.f23_1, coerceAtLeast(requiredCapacity, imul(this.f23_1.length, 2)));
      }
      h23(c) {
        this.a1x();
        var tmp = this.f23_1;
        var _unary__edvuaz = this.g23_1;
        this.g23_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      r1w() {
        return copyOf_5(this.f23_1, this.g23_1);
      }
    }
    initMetadataForClass($, 'ByteArrayBuilder');
    ByteArrayBuilderClass = $;
  }
  return ByteArrayBuilderClass;
}
var UByteArrayBuilderClass;
function UByteArrayBuilder() {
  if (UByteArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.p23_1 = bufferWithData;
        this.q23_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
        this.t1w(10);
      }
      p1w() {
        return this.q23_1;
      }
      t1w(requiredCapacity) {
        if (_UByteArray___get_size__impl__h6pkdv(this.p23_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.p23_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.p23_1), 2));
          tmp.p23_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
        }
      }
      r23(c) {
        this.a1x();
        var tmp = this.p23_1;
        var _unary__edvuaz = this.q23_1;
        this.q23_1 = _unary__edvuaz + 1 | 0;
        UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
      }
      f24() {
        var tmp0 = this.p23_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.q23_1;
        return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
      }
      r1w() {
        return new (UByteArray())(this.f24());
      }
    }
    initMetadataForClass($, 'UByteArrayBuilder');
    UByteArrayBuilderClass = $;
  }
  return UByteArrayBuilderClass;
}
var BooleanArrayBuilderClass;
function BooleanArrayBuilder() {
  if (BooleanArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.y23_1 = bufferWithData;
        this.z23_1 = bufferWithData.length;
        this.t1w(10);
      }
      p1w() {
        return this.z23_1;
      }
      t1w(requiredCapacity) {
        if (this.y23_1.length < requiredCapacity)
          this.y23_1 = copyOf_6(this.y23_1, coerceAtLeast(requiredCapacity, imul(this.y23_1.length, 2)));
      }
      a24(c) {
        this.a1x();
        var tmp = this.y23_1;
        var _unary__edvuaz = this.z23_1;
        this.z23_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      r1w() {
        return copyOf_6(this.y23_1, this.z23_1);
      }
    }
    initMetadataForClass($, 'BooleanArrayBuilder');
    BooleanArrayBuilderClass = $;
  }
  return BooleanArrayBuilderClass;
}
//region block: exports
export {
  BooleanArraySerializer_getInstance as BooleanArraySerializer_getInstance3a7llbc2ymdcm,
  ByteArraySerializer_getInstance as ByteArraySerializer_getInstance3p3rwnvaterxj,
  CharArraySerializer_getInstance as CharArraySerializer_getInstance3cpb3xmcmhcpk,
  DoubleArraySerializer_getInstance as DoubleArraySerializer_getInstance25mu6hrgxpomr,
  FloatArraySerializer_getInstance as FloatArraySerializer_getInstance3tko2kab5m31h,
  IntArraySerializer_getInstance as IntArraySerializer_getInstance2acxo7vnd0a54,
  LongArraySerializer_getInstance as LongArraySerializer_getInstance1wx2vu2ehlorg,
  ShortArraySerializer_getInstance as ShortArraySerializer_getInstance1g7lhbur6v7mu,
  UByteArraySerializer_getInstance as UByteArraySerializer_getInstance2no4cor7q9oza,
  UIntArraySerializer_getInstance as UIntArraySerializer_getInstance3ix9wqk8jrl6u,
  ULongArraySerializer_getInstance as ULongArraySerializer_getInstance3cysm5o5l0bk4,
  UShortArraySerializer_getInstance as UShortArraySerializer_getInstancezbhfz4zpzeud,
};
//endregion

//# sourceMappingURL=PrimitiveArraysSerializers.mjs.map
